var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectionMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5149_149155)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 39.0012,
    height: 39,
    rx: 19.5,
    fill: "#0078B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 13C16.6002 13 13 16.6 13 21C13 26.4 20.0003 32.5 20.3004 32.8C20.5004 32.9 20.8004 33 21.0004 33C21.2004 33 21.5004 32.9 21.7004 32.8C22.0004 32.5 29.0008 26.4 29.0008 21C29.0008 16.6 25.4006 13 21.0004 13ZM21.0004 30.7C18.9003 28.7 15.0001 24.4 15.0001 21C15.0001 17.7 17.7002 15 21.0004 15C24.3006 15 27.0007 17.7 27.0007 21C27.0007 24.3 23.1005 28.7 21.0004 30.7ZM21.0004 17C18.8003 17 17.0002 18.8 17.0002 21C17.0002 23.2 18.8003 25 21.0004 25C23.2005 25 25.0006 23.2 25.0006 21C25.0006 18.8 23.2005 17 21.0004 17ZM21.0004 23C19.9003 23 19.0003 22.1 19.0003 21C19.0003 19.9 19.9003 19 21.0004 19C22.1004 19 23.0005 19.9 23.0005 21C23.0005 22.1 22.1004 23 21.0004 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 39.0012,
    height: 39,
    rx: 19.5,
    stroke: "#005891",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5149_149155",
    x: 0,
    y: -1,
    width: 47,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5149_149155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5149_149155",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionMarker);
export default __webpack_public_path__ + "static/media/directionMarker.d000c9abd1113d7b63cf2adcabf99584.svg";
export { ForwardRef as ReactComponent };